var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonArrowSmallVertical2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 8"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.134 15.524c.189-.145.442-.163.647-.054l.085.054 7.5 5.77c.262.202.312.578.11.841-.182.236-.506.3-.76.163l-.082-.053-7.134-5.489-7.134 5.489c-.237.182-.565.16-.776-.038l-.066-.072c-.181-.236-.16-.565.038-.776l.072-.065 7.5-5.77z",
    transform: "translate(-179 -379) translate(0 364) matrix(1 0 0 -1 0 37.77)"
  }))));
}
export default SvgCommonArrowSmallVertical2;